import React, { useState } from "react";

const AuthModal = () => {
  const [isSignUp, setIsSignUp] = useState(true);
  const toggleForm = () => setIsSignUp(!isSignUp);

  return (
    <div
      className="modal fade"
      id="authModal"
      tabIndex="-1"
      aria-labelledby="authModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="container-fluid p-4">
            <p className="text-center text-success fw-bold">
              Let’s learn, share & inspire each other with our passion for
              computer engineering. Sign up now ✌️
            </p>
            <div className="row">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="d-flex fw-bold">
                  {isSignUp ? "Create Account" : "Sign In"}
                </h4>
                <button className="btn" onClick={toggleForm}>
                  {isSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
                  <span className="text-primary">
                    {isSignUp ? "Sign In" : "Create Account"}
                  </span>
                </button>
              </div>

              {/* Left Section: Form */}
              <div className="col-md-6 d-flex flex-column justify-content-center p-4">
                {isSignUp ? (
                  <form>
                    <div className="row mb-3">
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          required
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Last Name"
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div className="mb-3 position-relative">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        required
                      />
                      <span className="position-absolute end-0 me-3 top-50 translate-middle-y text-muted">
                        👁️
                      </span>
                    </div>
                    <div className="mb-3">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm password"
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-primary w-100 mb-3">
                      Create Account
                    </button>
                    <div className="d-flex flex-column gap-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                      >
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
                          alt="Facebook"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Sign Up with Facebook
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                      >
                        <img
                          src="https://imgs.search.brave.com/V7sgagRATLlWoAL9kKkWlvM1Lymxxb-2sk6dz3LnYrk/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy9j/L2MxL0dvb2dsZV8l/MjJHJTIyX2xvZ28u/c3Zn"
                          alt="Google"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Sign Up with Google
                      </button>
                    </div>
                  </form>
                ) : (
                  <form>
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div className="mb-3 position-relative">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        required
                      />
                      <span className="position-absolute end-0 me-3 top-50 translate-middle-y text-muted">
                        👁️
                      </span>
                    </div>
                    <button type="submit" className="btn btn-primary w-100">
                      Sign In
                    </button>
                  </form>
                )}
                <p className="text-muted mt-3">
                  By signing up, you agree to our{" "}
                  <span className="text-primary">Terms & Conditions</span> and{" "}
                  <span className="text-primary">Privacy Policy</span>.
                </p>
              </div>

              {/* Right Section: Image */}
              <div className="col-md-6 bg-light d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <img
                    src="https://dont-copy.netlify.app/assets/signup-OCG-APNN.svg"
                    alt="Sign Up Illustration"
                    className="img-fluid"
                    style={{ maxWidth: "80%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
